import moment from 'moment'

export function getCorrectDateRange({
  startDate,
  endDate,
  dateRangeGroupBy,
  dateRangeNumber,
}: {
  startDate?: string
  endDate?: string
  dateRangeGroupBy: string
  dateRangeNumber: number
}) {
  let correctedEndDate = endDate
    ? moment(endDate, 'YYYY-MM-DD')
    : moment().startOf('day')
  const startOfToday = moment().startOf('day')
  if (correctedEndDate.isAfter(startOfToday)) {
    correctedEndDate = startOfToday
  }
  const correctedEndDateStr = correctedEndDate.format('YYYY-MM-DD')

  const correctedStartDateStr = (() => {
    switch (dateRangeGroupBy) {
      case 'last_x_days':
        return correctedEndDate
          .clone()
          .subtract(dateRangeNumber, 'days')
          .format('YYYY-MM-DD')
      case 'last_x_weeks':
        return correctedEndDate
          .clone()
          .subtract(dateRangeNumber, 'weeks')
          .format('YYYY-MM-DD')
      case 'last_x_periods':
        return correctedEndDate
          .clone()
          .subtract(dateRangeNumber, 'months')
          .format('YYYY-MM-DD')
      default:
        return startDate ? startDate : correctedEndDateStr
    }
  })()

  return {
    startDate: correctedStartDateStr,
    endDate: correctedEndDateStr,
  }
}
